import React, { useState } from 'react';
import classes from './SliderComponent.module.scss';

function SliderComponent({ items = [], type }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const Dot = React.memo(({ isActive, onClick }) => (
    <div
      className={`${classes.dot} ${isActive ? classes.active : ''}`}
      onClick={onClick}
    ></div>
  ));

  return (
    <div className={`${classes.slider} ${classes[type]}`}>
      <div
        className={classes.slider_inner}
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {items.map((item, index) => (
          <div className={classes.slider_item} key={index}>
            {item}
          </div>
        ))}
      </div>
      <div className={classes.slider_dots}>
        {items.map((_, index) => (
          <Dot
            key={index}
            isActive={currentIndex === index}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
}

export default SliderComponent;
